import { FILE_ERROR_SET, FILE_URL_SET } from '../constants/action_constants';
import MIMETYPES from '../constants/mimetypes';
import RequestService from '../services/request_service';
import { newAlert } from './alert_actions';
import { completeRequest, sendRequest } from './request_state';

const nodeRequest = new RequestService('node');

export function setUrl(fileType, data, documentType = 'pdf') {
  return {
    type: FILE_URL_SET,
    documentType,
    fileType,
    data
  };
}

export function clearUrl(fileType) {
  return {
    type: FILE_ERROR_SET,
    fileType
  };
}

export const pdfVoucher = id => async dispatch => {
  dispatch(sendRequest('VoucherUrl'));
  try {
    const payload = await nodeRequest.post(
      `generate-pdf/voucher/${id}`,
      null,
      null
    );
    return getURL(payload);
  } catch (error) {
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar Voucher. Contácte con su administrador.'
      )
    );
  } finally {
    dispatch(completeRequest('VoucherUrl'));
  }
};

export const pdfPromissory = id => async dispatch => {
  dispatch(sendRequest('PromissoryUrl'));
  try {
    dispatch(clearUrl('promissory'));
    const payload = await nodeRequest.post(
      `generate-pdf/promissory`,
      { saleId: id },
      null
    );
    dispatch(setUrl('promissory', payload));
    return getURL(payload);
  } catch (error) {
    dispatch(clearUrl('promissory'));
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar Pagaré. Contácte con su administrador.'
      )
    );
  } finally {
    dispatch(completeRequest('PromissoryUrl'));
  }
};

export const pdfBin = id => async dispatch => {
  dispatch(sendRequest('BinUrl'));
  try {
    const payload = await nodeRequest.post(
      `generate-pdf/bin/${id}`,
      null,
      null
    );
    return getURL(payload);
  } catch (error) {
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar BIN. Contácte con su administrador.'
      )
    );
  } finally {
    dispatch(completeRequest('BinUrl'));
  }
};

export const pdfSecure = id => async dispatch => {
  dispatch(sendRequest('SecureUrl'));
  try {
    const payload = await nodeRequest.post(
      `generate-pdf/secure/${id}`,
      null,
      null
    );
    return getURL(payload);
  } catch (error) {
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar FIANZA. Contácte con su administrador.'
      )
    );
  } finally {
    dispatch(completeRequest('SecureUrl'));
  }
};

export const pdfRequestCardif = id => async dispatch => {
  dispatch(sendRequest('CardifUrl'));
  try {
    const payload = await nodeRequest.post(
      `generate-pdf/ensuranceRequest/${id}`,
      { docType: 1 },
      null
    );
    return getURL(payload);
  } catch (error) {
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar solicitud de cardif. Contácte con su administrador.'
      )
    );
  } finally {
    dispatch(completeRequest('CardifUrl'));
  }
};

export const pdfRequestCardifLayerTwo = id => async dispatch => {
  dispatch(sendRequest('CardifUrlLayerTwoUrl'));
  try {
    const payload = await nodeRequest.post(
      `generate-pdf/ensuranceRequest/${id}`,
      { docType: 2 },
      null
    );
    return getURL(payload);
  } catch (error) {
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar solicitud de cardif capa 2. Contácte con su administrador.'
      )
    );
  } finally {
    dispatch(completeRequest('CardifUrlLayerTwoUrl'));
  }
};

export const pdfSatisfactoryDeliveryFormat = () => async dispatch => {
  dispatch(sendRequest('SatisfactoryDeliveryFormatUrl'));
  try {
    const payload = await nodeRequest.post(
      `generate-pdf/satisfaction`,
      null,
      null
    );
    return getURL(payload);
  } catch (error) {
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar el documento de entregado a satisfacción. Contácte con su administrador.'
      )
    );
  } finally {
    dispatch(completeRequest('SatisfactoryDeliveryFormatUrl'));
  }
};

export const pdfAmortization = id => async dispatch => {
  dispatch(sendRequest('AmortizationUrl'));
  try {
    const payload = await nodeRequest.post(
      `generate-pdf/amortization/${id}`,
      null,
      null
    );
    return getURL(payload);
  } catch (error) {
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar el documento de amortización. Venta no existe en OSF.'
      )
    );
  } finally {
    dispatch(completeRequest('AmortizationUrl'));
  }
};

export const pdfPledge = id => async dispatch => {
  dispatch(sendRequest('PledgeUrl'));
  try {
    const payload = await nodeRequest.post(
      `generate-pdf/pledge/${id}`,
      null,
      null
    );
    return getURL(payload);
  } catch (error) {
    dispatch(
      newAlert(
        'error',
        'errors',
        'Error al generar el documento de pignoración. Venta no existe en OSF.'
      )
    );
  } finally {
    dispatch(completeRequest('PledgeUrl'));
  }
};

export const getURL = payload => {
  if (payload.blob) {
    return URL.createObjectURL(payload.blob);
  }

  const file = new Blob(
    [
      new Uint8Array(
        payload.bufferArray.data,
        payload.byteOffset,
        payload.bufferArray.data.length
      )
    ],
    { type: MIMETYPES['pdf'] }
  );
  return URL.createObjectURL(file);
};
